var logoFacebook = "https://shopfront-cdn.tekoapis.com/static/4a245cee42ae6bbb.svg";

export { logoFacebook as default };
